import React, { useEffect, useState } from "react";
import cross from "../../Images/Vector (14).png";
import HomeService from "../../Services/HomeService";

const CommunityCover = ({ modalChange }) => {
  const [advertisement, setAdvertisement] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  // Fetch advertisement data
  const fetchAllAdvertisement = async () => {
    try {
      const res = await HomeService.getAllAdvertisement();
      if (res?.status) {
        setAdvertisement(res.data);
      } else {
        console.error("Failed to fetch advertisements:", res?.message);
      }
    } catch (error) {
      console.error("Error fetching advertisements:", error);
    }
  };

  useEffect(() => {
    fetchAllAdvertisement();
  }, []);

  const handleSkip = () => {
    if (currentIndex < advertisement.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else {
      setCurrentIndex(0);
    }
  };

  const handleCancel = () => {
    modalChange();
  };

  return (
    <div className="community_wrapper65">
      <div className="community_cover_wrapper">
        {advertisement.length > 0 && (
          <div className="community_cover_img_div">
            <div className="community_property_img65">
              <img
                style={{
                  width: "100%",
                  maxWidth: "100%",
                  minWidth: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderRadius: "8px",
                }}
                src={advertisement[currentIndex]?.image}
                alt="Advertisement"
              ></img>

              <div className="cross_div" style={{ cursor: "pointer" }}>
                <img onClick={handleCancel} src={cross} alt="Close" />
              </div>
              <div className="community_property_name_div">
                <p>{advertisement[currentIndex]?.advertiseName}</p>
              </div>
              <div className="community_property_logo_div_wrapper5">
                <img
                  style={{
                    width: "100%",
                    maxWidth: "70%",
                    minWidth: "70%",
                    objectFit: "cover",
                  }}
                  // Display logo of the current advertisement
                  src={advertisement[currentIndex]?.logo}
                  alt="Logo"
                />
              </div>
            </div>

            <div className="like_skip_div_wrapper">
              <div className="like_skip_button_div">
                {/* Cancel button */}
                <button
                  className="skip_btn"
                  onClick={handleCancel} // Calls modalChange function to close modal
                >
                  Cancel
                </button>
                {/* Skip button */}
                <button
                  className="skip_btn"
                  onClick={handleSkip} // Calls handleSkip to show next advertisement
                >
                  Skip
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CommunityCover;
